import { render, staticRenderFns } from "./LogoutDialog.vue?vue&type=template&id=2c5280bc&scoped=true&"
import script from "./LogoutDialog.vue?vue&type=script&lang=js&"
export * from "./LogoutDialog.vue?vue&type=script&lang=js&"
import style0 from "./LogoutDialog.vue?vue&type=style&index=0&id=2c5280bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5280bc",
  null
  
)

export default component.exports